import React from 'react';

// T0 — Badge coloré. `color` = hex (module/agent/statut) -> teinte douce (alpha) + bordure.
// Sans `color`, rendu gris neutre (dark-mode natif).
export const Badge = ({ children, color, className = '' }) => {
  const style = color
    ? { backgroundColor: `${color}1A`, color, borderColor: `${color}33` }
    : undefined;
  return (
    <span
      style={style}
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${color ? '' : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 border-transparent'} ${className}`}
    >
      {children}
    </span>
  );
};

export default Badge;
